<template>
  <footer class="app-footer">
    <span><a href="http://www.origamieventos.com.br/" target="_blank">Origami Eventos</a> &copy; 2023.</span>
    <span class="ml-auto">
      Criado por <a href="https://www.extremedigital.com.br/eds/" target="_blank">EDS</a>
    </span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue